export const AMENITY_ROW_TYPES = {
  AMENITY_CATEGORY: 'AMENITY_CATEGORY',
  AMENITY_NAME: 'AMENITY_NAME',
};
